interface SharedWebSocket {
  ws: WebSocket | null;
}

export const sharedWebSocket: SharedWebSocket = { ws: null };
